export const templatesTypesToAskIfIsAPublishBulletin = ['agreement', 'judgment'];
